import IndexPage from './pages/home/index.vue';
import CoinPage from './pages/my-coin/coin-item.vue';
import CoinDetailPage from './pages/my-coin/coin-detail.vue';
import CoinDetailPage10 from './pages/my-coin/coin-detail10.vue';
import CoinDetailPage30 from './pages/my-coin/coin-detail30.vue';
import CoinDetailPage20 from './pages/my-coin/coin-detail20.vue';
import CoinDetailPage40 from './pages/my-coin/coin-detail40.vue';
import CoinDetailPage50 from './pages/my-coin/coin-detail50.vue';
import SettingsPage from './pages/users/settings.vue';
import PersonalPage from './pages/users/personal-default.vue';
import NewsPage from './pages/news/news.vue';
import CourseworkItem from './pages/academic-counseling/coursework-item.vue';
import HistoryRecordItem from './pages/academic-counseling/counseling/history-record.vue';
import CounselingRecord from './pages/academic-counseling/counseling/counseling-record.vue';
import RecordEditItem from './pages/academic-counseling/counseling/record-edit.vue';
import CounselingSearch from './pages/academic-counseling/counseling-apply/counseling-search.vue';
import ApplyPage from './pages/academic-counseling/counseling-apply/counseling-apply.vue';
import Teaching1Page from './pages/academic-counseling/teaching-counseling/teaching-step1.vue';
import Teaching2Page from './pages/academic-counseling/teaching-counseling/teaching-step2.vue';
import SoftPowerPage from './pages/soft-power/soft-power.vue';
import LearningInternship from './pages/learning-internship/learning-internship.vue';
import MediumDetailStudent from './pages/academic-counseling/medium/medium-detail-student.vue';
import MediumDetailTeacher from './pages/academic-counseling/medium/medium-detail-teacher.vue';
import CounselingRating from './pages/academic-counseling/counseling/counseling-rating.vue';
import login from './pages/users/log-in.vue';
import NotFoundPage from './pages/not-found.vue';


export default [
  {
    path: '/',
    component: IndexPage,
  },
  {
    path: '/my-coin',
    component: CoinPage,
  },
  {
    path: '/personal-default',
    component: PersonalPage,
  },
  {
    path: '/news',
    component: NewsPage,
  },
  {
    path: '/coin-detail',
    component: CoinDetailPage,
  },
  {
    path: '/coin-detail10',
    component: CoinDetailPage10,
  },
  {
    path: '/coin-detail20',
    component: CoinDetailPage20,
  },
  {
    path: '/coin-detail40',
    component: CoinDetailPage40,
  },
  {
    path: '/coin-detail30',
    component: CoinDetailPage30,
  },
  {
    path: '/coin-detail50',
    component: CoinDetailPage50,
  },
  {
    path: '/settings',
    component: SettingsPage,
  },
  {
    path: '/coursework',
    component: CourseworkItem,
  },
  {
    path: '/counseling-record',
    component: CounselingRecord,
  },
 {
    path: '/record-edit',
    component: RecordEditItem,
  },
  {
    path: '/search',
    component: CounselingSearch,
  },
  {
    path: '/apply',
    component: ApplyPage,
  },
  {
    path: '/teaching1',
    component: Teaching1Page,
  },
  {
    path: '/teaching2',
    component: Teaching2Page,
  },
  {
    path: '/soft-power',
    component: SoftPowerPage,
  },
  {
    path: '/learning-internship',
    component: LearningInternship,
  },
  {
    path: '/medium-detail-student',
    component: MediumDetailStudent,
  },
  {
    path: '/medium-detail-teacher',
    component: MediumDetailTeacher,
  },
  {
    path: '/counseling-record/counseling-rating',
    component: CounselingRating,
  },
  {
    path:'/login',
    component:login
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];



// WEBPACK FOOTER //
// ./src/routes.js